import Card from "../../components/card/Card";
import {useFormik} from "formik";
import ModalMsg from "../../components/ModalMsg";
import React, {useState} from "react";
import {Link} from "react-router-dom";
import Translate from "../../components/Translate";
import NsField from "../../components/fields/NsField";
import {inviaEmailRecuperoPasswordApi} from "./services/RecuperoPasswordServices";

export default function RecuperaPwdController() {

    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const formik = useFormik({
        initialValues: {
            mail: ''
        }, onSubmit: async values => {
            const response = inviaEmailRecuperoPasswordApi(values);
            setModalMsg(response.data.description);
            setShow(true);
        }
    });

    return (
        <Card
            icon={'fas fa-key'}
            title={'Recupera password'}
            subtitle={'Inserisci il tuo indirizzo e-mail e ti verrà inviato un link per cambiare la tua password'}
        >
            <div className="ns-login ns-recupera-pwd">
                <ModalMsg
                    show={show}
                    handleClose={() => setShow(false)}
                    testo={modalMsg}/>
                <form className="row g-3 needs-validation"
                      method="post"
                      noValidate=""
                      onSubmit={formik.handleSubmit}>
                    <div className="col-12">
                        <NsField
                            id="mail"
                            label={"E-mail:"}
                            name="mail"
                            type="mail"
                            onChange={formik.handleChange}
                            valoreNoFormik={formik.values.mail}
                            isRequired={true}
                        />
                        <div className="invalid-feedback">
                            <Translate>L'indirizzo E-Mail deve essere valorizzato.</Translate>
                        </div>
                    </div>
                    <div className="d-grid gap-2">
                        <button type="submit" name="conferma" id="conferma" className="btn btn-dark">
                            <i className="fas fa-user-lock"/> <Translate>Conferma</Translate>
                        </button>
                        <Link to="/" className="btn btn-dark">
                            <i className="fas fa-sign-in-alt"/> <Translate>Login</Translate>
                        </Link>
                    </div>
                </form>
            </div>
        </Card>
    )
}
